import { catColor, catLabel } from "../lib/constants";

export function CategoryChips({ value, onChange, categories, allLabel = "Tutte" }) {
    return (
        <div
            className="flex items-center gap-2 overflow-x-auto no-scrollbar pb-1"
            data-testid="category-chips"
        >
            <Chip
                active={!value}
                onClick={() => onChange("")}
                testid="chip-all"
                color="#1a2a44"
            >
                {allLabel}
            </Chip>
            {categories.map((c) => {
                const color = catColor(c);
                return (
                    <Chip
                        key={c}
                        active={value === c}
                        onClick={() => onChange(c)}
                        testid={`chip-${c.toLowerCase()}`}
                        color={color}
                    >
                        {catLabel(c)}
                    </Chip>
                );
            })}
        </div>
    );
}

function Chip({ active, onClick, children, testid, color }) {
    return (
        <button
            type="button"
            data-testid={testid}
            onClick={onClick}
            className={`whitespace-nowrap rounded-full px-4 py-1.5 text-[12px] font-semibold uppercase tracking-wider transition-all duration-200 border ${
                active ? "text-white shadow-sm" : "bg-white text-brand-ink/70 border-brand-line hover:border-brand-gold/50"
            }`}
            style={
                active
                    ? { background: color, borderColor: color }
                    : undefined
            }
        >
            {children}
        </button>
    );
}
